module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "container-fluid mb-4 p-2 text-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "m-auto py-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/menu_logo_o.png"),
      "alt": "ohiruneart_logo"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fbfb780!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/LoginHeader.vue
// module id = 318
// module chunks = 1